<template>
  <!-- Layout inner -->
  <div class="layout-inner pg_content course_about program pathways requirements">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">
        <template v-if="showLoader">
          <div class="w-100 h-100 d-flex justify-content-center align-items-center">
            <spinner size="large"></spinner>
          </div>
        </template>
        <template v-if="showPage">

          <template v-if="programGuide && programGuide.title">
            <program-guide-title :program-guide="programGuide"></program-guide-title>
          </template>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 pg_content_container">

            <div class="row result_row">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 thumbnail_container">
                <div class="thumbnail_container_inner">
                  <img class="thumb_img" v-if="programGuide.thumbnailURL" :src="programGuide.thumbnailURL" tabindex="0">
                  <div v-else class="default_thumb">
                    <span class="ic ic-degreeProgram"></span>
                  </div>
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 entity_details">

                <div v-if="showMedianIncome" class="row" :aria-label="'median income ' + currencyLabel + programGuide.medianIncomePerYear" tabindex="0">
                    <div class="label">{{medianIncomeLabel}}</div>
                    <div class="val" v-if="programGuide.medianIncomePerYear">
                      {{currencyLabel}} <span v-html="addCommaInNumber(programGuide.medianIncomePerYear)"></span>
                    </div>
                    <div class="val no_data" v-else>N/A</div>
                </div>

                <div v-if="showJobPostings" class="row" :aria-label="'job postings ' + programGuide.totalJobPostings" tabindex="0">
                    <div class="label">{{jobPostingsLabel}}</div>
                    <div class="val" v-if="programGuide.totalJobPostings">
                      <span v-html="addCommaInNumber(programGuide.totalJobPostings)"></span>
                    </div>
                    <div class="val no_data" v-else>N/A</div>
                </div>

                <div v-if="showGrowthRate" class="row" :aria-label="'growth rate ' + programGuide.growthRate" tabindex="0">
                    <div class="label">{{growthRateLabel}}</div>
                    <div class="val" v-if="programGuide.growthRate">{{programGuide.growthRate}}%</div>
                    <div class="val no_data" v-else>N/A</div>
                </div>

              </div>

            </div>

            <template v-if="showPathwayDetail">
              <h2>
                <div class="hd_bar" style="background: #dbf5ff; box-shadow: none;">
                  <div class="hd_ic" @click="hideSelectedPathway">
                    <span class="ic ic8-arrow-left2"></span>
                  </div>
                  <div class="hd_txt">
                    <span class="title_txt">{{selectedPathway.title}}</span>
                  </div>
                </div>
              </h2>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 hd" style="margin-left: -10px; margin-bottom: 15px;">
                  <h2><span>Pathways</span></h2>
                  <span class="hd_bdr"></span>
                </div>
              </div>
            </template>


            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <template v-if="!showPathwayDetail">
                  <template v-if="programGuide.pathwayProgramGuides.length == 0">
                    <div class="msg_no_data empty_pattern ace_sec_txt">
                      This program doesn't have any pathways.
                    </div>
                  </template>
                  <template v-if="programGuide.pathwayProgramGuides.length > 0">
                    <ul class="concentrations_list">
                      <li v-for="path in programGuide.pathwayProgramGuides" @click="showSelectedPathway(path)">{{path.title}}</li>
                    </ul>
                  </template>
                </template>
                <template v-if="showPathwayDetail">
                  <div @click="click" v-html="selectedPathway.requirements" ref="reqParentDiv"></div>
                </template>
              </div>
            </div>

          </div>
          <!-- / Page content -->

          <program-footer-navbar :pageTitle="'Pathways'" :returnTo="'programGuideMenu'" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>

        </template>
      </div>
    </div>
  </div>
  <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'program-guide-pathways',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      showPage: false,
      showLoader: true,
      programGuide: {},
      selectedPathway: {},
      showPathwayDetail: false
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadInstitutionPackage'
    ]),
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.showLoader = false
      this.showPage = true
    },
    bindClickEventOnSubCategory () {
      let parentElem = this.$refs['reqParentDiv']
      let elems = $(parentElem).find('.pg_sec_head')
      if (elems && elems.length > 0) {
        for (let i = 0; i < elems.length; i++) {
          let elem = elems[i]
          let reqCode = $(elem).attr('id')
          $(elem).css('background', '#ECF8FC')
          $(elem).first().click(() => {
            this.updatePageSecCssClass(reqCode)
          })
        }
      }
    },
    updatePageSecCssClass (pgSectionId) {
      let isActiveClass = $('#accordionCrdContent_' + pgSectionId).hasClass('active')
      if (isActiveClass) {
        $('#' + pgSectionId).removeClass('active')
        $('#accordionCrdContent_' + pgSectionId).removeClass('active')
        $('#accordionCrdContent_' + pgSectionId).css('display', 'none')
      } else {
        $('#' + pgSectionId).addClass('active')
        $('#accordionCrdContent_' + pgSectionId).addClass('active')
        $('#accordionCrdContent_' + pgSectionId).css('display', 'block')
      }
    },
    showSelectedPathway (pathway) {
      this.selectedPathway = pathway
      this.showPathwayDetail = true
      this.$nextTick(() => {
        this.bindClickEventOnSubCategory()
      })
    },
    hideSelectedPathway () {
      this.selectedPathway = {}
      this.showPathwayDetail = false
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    },
    click (e) {
      e.preventDefault()
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },

    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },

    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },

    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },

    currencyLabel () {
      return '$'
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuidePathways.vue